<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { smartRounding } from '../../telematics/tools/smartRounding/index.js';
    import Duration from '../../../shared/Duration.svelte';
    import Distance from '../../../shared/Distance.svelte';

    export let details: Record<string, (number|null)[]>;
    export let title: string = $_('route_cost_details');
    export let total: number|null = null;
    export let currency: string = '';

    let sections: Record<string, Function> = {
        operational: (k: string) => !k.match(/^tolls_/),
        tolls: (k: string) => k.match(/^tolls_/)
    };

    for (let s in sections) {
        let empty = true;
        for (let i in details) {
            if (sections[s](i) && details[i]) {
                empty = false;
            }
        }
        if (empty) {
            delete(sections[s]);
        }
    }

</script>

<div>
    {#if title || total}
        <div class="title">
            <div>{title}</div>
            {#if total}
                <div class="cost_total">
                    {new smartRounding().getFormatedValue(total, '', {convert_nicer: true})}
                    <div class="lite" style="padding:0 0 0 2px; font-size: 13px;">{currency}</div>
                </div>
            {/if}
        </div>
    {/if}
    <div class="cost_details">
        {#each Object.entries(sections) as [section, tester]}
            <div class="cost_section">{$_('route_cost_'+section)}</div>
            {#each Object.entries(details) as [key, item]}
                {#if item[1] && tester(key)}
                    <div class="cost_detail_type"><span>{$_('route_cost_'+key)}</span></div>
                    <div class="cost_detail_amount"><span>
                        {#if item[0]}
                            {#if ['distance', 'tolls_etoll', 'tolls_highways'].includes(key)}
                                <Distance meters={item[0]}/>
                            {:else if key == 'duration'}
                                <Duration seconds={item[0]}/>
                            {:else}
                                {item[0]}
                            {/if}
                        {/if}
                    </span></div>
                    <div class="cost_detail_value"><span>
                        {new smartRounding().getFormatedValue(item[1], '', {convert_nicer: true})}
                        <div class="lite" style="padding:0 0 0 2px; font-size: 12px;">
                            {currency}
                        </div>
                    </span></div>
                {/if}
            {/each}
        {/each}
    </div>
</div>

<style>
    .title {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 600;
        white-space: nowrap;
        padding-bottom: 4px;
        margin-bottom: 5px;
        border-bottom: 1px solid #999;
    }
    .cost_total {
        display: flex;
        align-items: baseline;
    }
    .cost_details {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr;
        gap: 1px 30px;
        overflow: hidden;
    }
    .cost_section {
        grid-column: 1 / 4;
        font-weight: 600;
    }
    .cost_details>div.cost_section::before {
        border-bottom: 0;
    }
    .cost_details>div {
        white-space: nowrap;
        position: relative;
    }
    .cost_details>div::before {
        content: '';
        position: absolute;
        bottom: 4px;
        left: 0;
        right: -50px;
        border-bottom: 1px solid #ccc;
    }
    .cost_details>div>span {
        display: flex;
        align-items: baseline;
        position: relative;
        z-index: 1;
        background-color: rgb(245, 245, 245);
        padding: 0 3px;
        white-space: nowrap;
    }
    .cost_details>div.cost_detail_type>span {
        display: inline-block;
        padding-left: 8px;
    }
    .cost_detail_amount {
        display: flex;
        align-items: baseline;
        justify-content: right;
        color: #888;
    }
    .cost_detail_value {
        display: flex;
        align-items: baseline;
        justify-content: right;
    }
</style>
